<div class="table-expand-editable">
  <section class="fixed-header mat-elevation-z8" tabindex="0">
    <table mat-table [dataSource]="dataSource" [id]="tableIdChangeBasedOnPage()" multiTemplateDataRows
      class="mat-elevation-z8">
      <ng-container *ngFor="let column of columnsToDisplay" [matColumnDef]="column.id">
        <th mat-header-cell *matHeaderCellDef>
          <div [ngSwitch]="column.type">
            <div class="rightAlignString" *ngSwitchCase="'rightAlignString'">
              {{column.title}}
            </div>
            <div *ngSwitchDefault>
              {{column.title}}
            </div>
          </div>
        </th>
        <td mat-cell *matCellDef="let row;let i = dataIndex">
          <div class="cellHeight" [ngSwitch]="column.type">
            <div *ngSwitchCase="'editableString'">
              <div [ngSwitch]="row[key]">
                <div *ngSwitchCase="id">
                  <div class="sizeReducedInput">
                    <mat-form-field class="example-full-width">
                      <input matInput value={{column.value(row)}} (input)="onChange(i ,column.id ,$event)">
                    </mat-form-field>
                  </div>
                </div>
                <div *ngSwitchDefault>
                  {{column.value(row)}} </div>
              </div>
            </div>

            <div *ngSwitchCase="'editableNumber'">
              <div [ngSwitch]="row[key]">
                <div *ngSwitchCase="id">
                  <div class="sizeReducedInput">
                    <mat-form-field class="example-full-width"> <input matInput type="number"
                        value={{column.value(row)}}>
                    </mat-form-field>
                  </div>
                </div>
                <div *ngSwitchDefault>
                  {{column.value(row)}} </div>
              </div>
            </div>

            <div class="number" *ngSwitchCase="'number'">
              <div>
                {{column.value(row)}}
              </div>
            </div>

            <div *ngSwitchCase="'repoUrl'">
              <div class="repoUrl width-180" [matTooltip]="column.value(row)">
                {{cf.removeGitHub(column.value(row))}}
              </div>
            </div>

            <div *ngSwitchCase="'ymlFile'">
              <div class="ymlFile width-180" [matTooltip]="column.value(row)">
                {{column.value(row)}}
              </div>
            </div>

            <div *ngSwitchCase="'wfName'">
              <div *ngIf="isEditActive && editableColumnIndex.value === row.value" class="updCngNm">
                <div [formGroup]="workflowForm">
                  <mat-form-field class="example-full-width">
                    <mat-label>Configuration name</mat-label>
                    <input matInput [(ngModel)]="editedValue" formControlName="cngName" required>
                    <mat-error
                      *ngIf="workflowForm.controls['cngName'].errors?.['required'] || workflowForm.controls['cngName'].errors?.['maxlength']">{{getConfigurationName()}}</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div *ngIf="!isEditActive || editableColumnIndex.value !== row.value" class="width-20rem wfName"
                [matTooltip]="column.value(row)">
                {{ column.value(row) }}
              </div>
            </div>

            <div *ngSwitchCase="'manualWfNm'" class="width-130 wfName" [matTooltip]="column.value(row)">
              {{ column.value(row) }}
            </div>

            <div *ngSwitchCase="'status'">
              <div class="width-80" [matTooltip]="column.value(row)">
                {{column.value(row)}}
              </div>
            </div>

            <div *ngSwitchCase="'editableSelect'">
              <div [ngSwitch]="row[key]">
                <div *ngSwitchCase="id">
                  <div class="sizeReducedSelector">
                    <mat-form-field appearance="fill">
                      <mat-select value={{column.value(row)}} (selectionChange)="onChange(i,column.id ,$event)">
                        <mat-option *ngFor="let option of column.options" [value]="option.text">
                          {{option.text}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div *ngSwitchDefault>
                  {{column.value(row)}} </div>
              </div>
            </div>
            <div *ngSwitchCase="'status'">
              <app-type-specific-status [type]=false statusName={{column.value(row)}}></app-type-specific-status>
            </div>
            <div *ngSwitchCase="'specificStatus'">
              <app-type-specific-status [type]=true specifiedType="Overall" statusName={{column.value(row)}}>
              </app-type-specific-status>
            </div>

            <div class="normal">
              <div *ngSwitchCase="'normal'">
                <div>
                  {{column.value(row)}}
                </div>
              </div>
            </div>

            <div *ngSwitchCase="'editableStatus'">
              <div [ngSwitch]="row[key]">
                <div *ngIf="isEditActive && editableColumnIndex.value === row.value" class="statusDropdown"
                  [formGroup]="workflowForm">
                  <mat-form-field appearance="fill">
                    <mat-label>Status</mat-label>
                    <mat-select id="mat-select" value={{column.value(row)}} (valueChange)="statusValChange($event)">
                      <mat-option *ngFor="let option of column.options" [value]="option.value.toString()">
                        {{ option.text }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div *ngIf="!isEditActive || editableColumnIndex.value !== row.value">
                  <app-type-specific-status [type]=false statusName={{column.value(row)}}></app-type-specific-status>
                </div>
              </div>
            </div>

            <div *ngSwitchCase="'editableSpecificStatus'">
              <div [ngSwitch]="row[key]">
                <div *ngSwitchCase="id">
                  <div class="sizeReducedSelector">
                    <mat-form-field appearance="fill">
                      <mat-select value={{column.value(row)}} (selectionChange)="onChange(i,column.id ,$event)">
                        <mat-option *ngFor="let option of column.options" [value]="option.value">
                          {{option.value}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div *ngSwitchDefault>
                  <app-type-specific-status [type]=true specifiedType={{column.specifiedType}}
                    statusName={{column.value(row)}}>
                  </app-type-specific-status>
                </div>
              </div>
            </div>
            <div *ngSwitchCase="'regexp'">
              <div [ngSwitch]="row[key]">
                <div *ngSwitchCase="id">
                  <div class="sizeReducedInput">
                    <mat-form-field class="example-full-width"> <input matInput value={{column.value(row)}}>
                    </mat-form-field>
                  </div>
                </div>
                <div *ngSwitchDefault>
                  {{column.value(row)}} </div>
              </div>
            </div>
            <div *ngSwitchCase="'activeFlg'" class="activeFlg width-150"
              [id]="tourGuideIds.githubAction.tableContent.status.id"
              [ngClass]="{'disabled-cursor': !tourGuideService.isStartTour && !authService.permissions['run-github-action']}">
              <mat-form-field style="height: 3rem; width: 100%;">
                <mat-label>Status</mat-label>
                <mat-select id="mat-select" (selectionChange)="onStatusChange($event, row, i)" #selectStatus
                  value={{column.value(row)}}
                  [disabled]="!tourGuideService.isStartTour && !authService.permissions['run-github-action']">
                  <mat-option *ngFor="let option of column.options" [value]="option.value.toString()">
                    {{ option.text }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div *ngSwitchDefault> {{column.value(row)}}
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="editButton">
        <th mat-header-cell *matHeaderCellDef aria-label="row actions"></th>
        <td mat-cell *matCellDef="let element;let i = dataIndex">
          <div *ngIf="editable">
            <div class="actionContainer">
              <div class="icon-container"
                matTooltip="{{!authService.permissions['edit-config'] ? cf.messages.permissionMsg : editIcon}}"
                [ngClass]="{ 'disabled-cursor': !tourGuideService.isStartTour && !authService.permissions['edit-config'] }">
                <mat-icon
                  [ngClass]="{ 'disabled': !tourGuideService.isStartTour && !authService.permissions['edit-config'] }"
                  (click)="toggleExpandElement(element, i); $event.stopPropagation();" class="edit-icon cursor"
                  [id]="tourGuideIds.configBuilder.workflow.configTableEdit.id">edit</mat-icon>
              </div>
              <div class="icon-container"
                matTooltip="{{!authService.permissions['delete-config'] ? cf.messages.permissionMsg : deleteIcon}}"
                [ngClass]="{ 'disabled-cursor': !tourGuideService.isStartTour && !authService.permissions['delete-config'] }">
                <mat-icon [id]="tourGuideIds.configBuilder.workflow.configTableDelete.id" class="delete-icon cursor"
                  [ngClass]="{ 'disabled': !tourGuideService.isStartTour && !authService.permissions['delete-config'] }"
                  (click)="onDelete(i)">delete</mat-icon>
              </div>
            </div>
            <!-- <div class="actionContainer" *ngIf="id !== undefined && element[key]===id ">
          <div class="icon-container" [matTooltip]="saveIcon"  (click)="onSave(i)">
            <i class="fa fas colorPrimary fa-lg fa-save"></i>
          </div>
          <div class="icon-container" [matTooltip]="cancelIcon" (click)="onCancel(i)">
            <i class="fa fa-solid colorRed fa-lg fa-close"></i>
          </div>
        </div> -->
          </div>
        </td>
      </ng-container>

      <!--Column to display the content for manual workflow trigger page-->
      <ng-container matColumnDef="manualWfRun">
        <th mat-header-cell *matHeaderCellDef aria-label="row actions">Action</th>
        <td mat-cell *matCellDef="let element;let i = dataIndex" style="min-width: 12rem;">
          <div *ngIf="editable">
            <div class="justify-content-center">
              <div class="button-container">
                <button mat-raised-button color="primary" [disabled]="targetExec ? 'false' : !element.active" class="run-workflow-button"
                  [id]="tourGuideIds.githubAction.tableContent.runWf.id" 
                  (click)="toggleElement(element, i); $event.stopPropagation(); mode= targetExec ? 'edit' : authService.permissions['run-github-action'] ? 'edit' : 'read'">
                  <span>Run workflow</span>
                  <mat-icon>
                    {{ arrowUp && expandedElement === element ? 'arrow_drop_up' : 'arrow_drop_down' }}
                  </mat-icon>
                </button>
              </div>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="expand">
        <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
        <td mat-cell *matCellDef="let element, let i = dataIndex"
          [class.example-expanded-row]="expandedElement === element"
          (click)="expandedElement = expandedElement === element ? null : element">
          <div class="icon-container" *ngIf="expandable"
            (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
            <div *ngIf="expandedElement !== element" class="cursor" [matTooltip]="expandIcon" aria-hidden="true"
              (click)="mode='read'; expand(element,i)"><mat-icon>add</mat-icon></div>
            <div *ngIf="expandedElement === element" class="cursor" [matTooltip]="collapseIcon" aria-hidden="true"
              (click)="remove()">
              <mat-icon>remove</mat-icon>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td class="expandend-card-td fit-content" mat-cell *matCellDef="let element"
          [attr.colspan]="columnsToDisplayWithExpand.length">
          <div *ngIf="element == expandedElement" class=" example-element-detail "
            [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
            <div class="expanded-component-container">
              <!-- <app-config-expanded  [data]="element" [mode]="mode"></app-config-expanded> -->
              <app-workflow-config [configHide]="false" [mode]="mode" [isEditable]="true" [element]="expandedElement"
                [isAddConfig]="true" (isExpandable)="updateExpand($event)" [manualWf]=manualWf
                (cancelUpdClicked)="isEdit($event)" [cngName]="this.workflowForm.value.cngName" [cngStatus]="cngStatus"
                [cngNameUpdValid]="this.workflowForm.valid" [targetExec]="targetExec" [jobId]="jobId"></app-workflow-config>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand; sticky: true"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;" class="example-element-row">
      </tr>
      <div *ngIf="expandable">
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
      </div>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan=6>
          <div class="emptyData">
            <app-no-data-available [newData]="getNoData"></app-no-data-available>
          </div>
        </td>
      </tr>
    </table>
  </section>
  <mat-paginator *ngIf="!targetExec" [pageSizeOptions]="constantsService.pageSizeOptions" showFirstLastButtons
    aria-label="Select page of periodic elements" class="paginator2">
  </mat-paginator>
</div>